import React, { useState, useEffect, useCallback, forwardRef, useImperativeHandle, useRef } from 'react';
import Select from 'react-select';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from 'axios';
import debounce from 'lodash/debounce';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { Button, Card, Container, Row, Col, Form, OverlayTrigger, Tooltip, InputGroup } from 'react-bootstrap';
import { v4 as uuidv4 } from 'uuid';
import { alertconfirmation } from '../../alerts/Alerts';
import { FaDownload } from "react-icons/fa";
import config from '../../config';
import { uploadedFileAlert, planRulebox } from '../../alerts/Alerts';


import DirectBillPlanCoverageComponent from './DirectBillPlanCoverageComponent'

const PlansComponent = forwardRef(({
    apiEndpoint,
    caseId,
    renewalCase,
    fetchUrl,
    updateUrl,
    deleteUrl,
    addUrl,
    planName,
    formFields,
    selectOptions,
    isDisableForUsers,
    initialFormValues = {},
    onError = () => { }
}, ref) => {
    const [plans, setPlans] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [validationErrors, setValidationErrors] = useState({});

    const [leftDivisions, setLeftDivisions] = useState([]);
    const [rightDivisions, setRightDivisions] = useState([]);
    const [selectedLeft, setSelectedLeft] = useState([]);
    const [selectedRight, setSelectedRight] = useState([]);
    const [selectedFile, setSelectedFile] = useState({});
    const [uploadStatus, setUploadStatus] = useState("");

    const [userName, setUserName] = useState(sessionStorage.getItem('username'));

    
    const [isOpen, setIsOpen] = useState(true);

    const [files, setFiles] = useState([]);
    const [selectedFileName, setSelectedFileName] = useState({
        ageGender: '',
        sbc: ''
    });



    const resetForm = () => {
        setSelectedFile({});
        setSelectedFileName({
            ageGender: '',
            sbc: ''
        });
    };

    const coverageRatesRefs = useRef([]);


    useEffect(() => {
        fetchPlans();
        fetchCaseFiles();
        fetchDirectBillGroups();
        
    }, []);

    

    const [localSelectOptions, setLocalSelectOptions] = useState(selectOptions);

    useEffect(() => {
        const loadOptions = async () => {
            const carriers = await getCarrierOptions();
    
            setLocalSelectOptions(prev => ({
                ...prev,
                carrierName: carriers
            }));

            
        };
        console.log(localSelectOptions)
        loadOptions();
    }, []);


     const getCarrierOptions = async () => {
        try {
            const response = await fetch(`${config.API_URL}/RenewalCases/carriers`);
    
            if (!response.ok) {
                throw new Error('Failed to fetch carriers');
            }
    
            const data = await response.json();
            
    
            return data
        } catch (error) {
            console.error('Error loading carriers:', error);
            return [];
        }
    };

    
    



    const fetchPlans = async () => {
        try {
            const response = await axios.get(fetchUrl);
            const data = response.data;

            // Retrieve existing data from local storage
            const storedData = localStorage.getItem('carrierNames');
            const carrierNamesMap = storedData ? JSON.parse(storedData) : {};

            // Initialize an array for the current case ID if it doesn't exist
            if (!carrierNamesMap[caseId]) {
                carrierNamesMap[caseId] = [];
            }

            // Create a Set to avoid duplicates for the current case ID
            const carrierNamesSet = new Set(carrierNamesMap[caseId]);

            // Collect unique carrier names from the API response
            data.forEach(el => {
                if (el.carrierName) {
                    carrierNamesSet.add(el.carrierName);
                }
            });

            // Convert Set to an array and update the map for the current case ID
            carrierNamesMap[caseId] = Array.from(carrierNamesSet);

            // Store the updated map in local storage
            localStorage.setItem('carrierNames', JSON.stringify(carrierNamesMap));
            setPlans(response.data || []);
        } catch (error) {
            if (error.response?.status !== 404) {
                setError('Error fetching case files.');
            }
            onError(error);
        } finally {
            setLoading(false);
        }
    };

    const fetchCaseFiles = async () => {
        try {
            const response = await axios.get(`${config.API_URL}/CaseFiles/${caseId}`);
            setFiles(response.data || []);
        } catch (error) {
            if (error.response?.status !== 404) {
                setError('Error fetching files.');
            }
            onError(error);
        } finally {
            setLoading(false);
        }
    };

    const fetchDirectBillGroups = async () => {
        try {
            const response = await axios.get(`${config.API_URL}/DirectBillGroups/GetDirectBillGroupsByCaseId/${caseId}`);

            setRightDivisions(response.data || []);
            setLeftDivisions(response.data || []);


        } catch (error) {
            if (error.response?.status !== 404) {
                setError('Error fetching files.');
            }
            onError(error);
        } finally {
            setLoading(false);
        }
    };

    const getFileNameFromURL = (url) => {
        try {
            const urlObject = new URL(url);
            const fileName = decodeURIComponent(urlObject.pathname.split('/').pop());
            const fileNameWithoutId = fileName.split('_').slice(0, -1).join('_');
            return fileNameWithoutId;
        } catch (error) {
            console.error('Invalid URL:', url);
            return '';
        }
    };


    const handleFileChange = (index, planId, category, event) => {
        
        const file = event.target.files[0];
        
        if (file) {

            setSelectedFile(prevState => ({
                ...prevState,
                [`${planId}-${index}-${category}`]: file
            }));


            setSelectedFileName(prevState => ({
                ...prevState,
                [`${planId}-${index}-${category}`]: file.name
            }));


            console.log("Selected file for", `${planId}-${index}-${category}:`, file);
        }
    };

     const sanitize = (text) =>
        text
          ?.toString()
          .trim()
          .replace(/[^a-zA-Z0-9-]/g, '');
      
       const getTimestamp = () => {
        const now = new Date();
        return now.toISOString()
          .replace(/[-:]/g, '')
          .split('.')[0]
          .replace('T', '-');
      };
      
       
       const formatDate = (dateInput) => {
        if (!dateInput) return "00000000";
      
        const date = new Date(dateInput);
      
        // Handle invalid date
        if (isNaN(date)) return "00000000";
      
        const pad = (n) => n.toString().padStart(2, "0");
      
        return (
          date.getFullYear() +
          pad(date.getMonth() + 1) +
          pad(date.getDate())
        );
      };
      
       const buildFileName = ({
        benCode,
        renewalDate,
        category,
        carrier,
        filePlanName,
        originalFileName
      }) => {
        const ext = originalFileName.includes('.')
          ? originalFileName.split('.').pop()
          : 'dat';
      
        return [
          sanitize(benCode),
          renewalDate,
          sanitize(category),
          sanitize(carrier),
          sanitize(filePlanName),
          getTimestamp()
        ].join('-');
      };


      


      

      
    const uploadDirectBillBenefitsFile = async (index, planId, fileCategory, carrierName, filePlanName) => {
        const fileKey = `${planId}-${index}-${fileCategory}`;
        const fileToUpload = selectedFile[fileKey];

        if (!fileToUpload) {
            setUploadStatus("No file selected.");
            return;
        }

        const fileName = buildFileName({
            benCode: "BENRENEW",
            renewalDate: formatDate(renewalCase?.renewalDate),
            category: fileCategory === "Summary of Benefits and Coverage (SBC) Documents"? "SBCDocuments":fileCategory,
            carrier: carrierName,
            filePlanName: filePlanName,
            originalFileName: fileToUpload.name
          });

        const formData = new FormData();
        formData.append("file", fileToUpload, fileName);

        try {
            // Upload file to blob storage
            const blobResponse = await axios.post(`${config.API_URL}/BlobUploads/upload`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });

            const fileUrl = blobResponse.data.fileUrl;
            setUploadStatus(`File uploaded successfully: ${fileUrl}`);

            // Save file metadata
            const caseFile = {
                fileURL: fileUrl,
                plan: planName,
                meta: planId,
                fileCategory: fileCategory,
                status: "Uploaded",
                uploadedBy: userName,
                uploadedDate: new Date().toISOString(),
                caseId: caseId
            };

            await axios.post(`${config.API_URL}/CaseFiles`, caseFile);
            setUploadStatus(`File and metadata saved successfully: ${fileUrl}`);


            uploadedFileAlert(resetForm);
            
            fetchCaseFiles();


            if(fileCategory === "Age/Gender Banded Rates"){
                if (validationErrors[index]) {
                    delete validationErrors[index]['fileUpload'];
                }
            }
        } catch (error) {
            console.error("Error during file upload or case file save:", error);
            setUploadStatus("File upload or case file save failed.");
        }
    };


    const handleDeleteFile = async (planId, fileUrl, fileId, fileCategory) => {
        try {
            const caseFile = {
                fileURL: fileUrl,
                plan: planName,
                meta: planId,
                fileCategory,
                status: "Deleted",
                deletedBy: userName,
                deletedDate: new Date().toISOString(),
                caseId: caseId
            };
    
            await Promise.all([
                axios.post(`${config.API_URL}/CaseFiles`, caseFile),
                axios.delete(`${config.API_URL}/CaseFiles/${fileId}`)
            ]);
    
            fetchCaseFiles();
        } catch (error) {
            console.error('Error deleting file:', error);
            onError(error);
        }
    };
    


    const toggleCollapsible = () => {
        setIsOpen(!isOpen);
    };


    const debouncedUpdate = useCallback(
        debounce(async (fieldName, value, planId) => {

            try {
                const patchDocument = [
                    { op: 'replace', path: `/${fieldName}`, value: value }
                ];
                const url = `${updateUrl}/${planId}`;
                await axios.patch(url, patchDocument);
            } catch (error) {
                console.error('Error updating field:', error);
                onError(error);
            }

        }, 500),
        [updateUrl, onError, validationErrors]
    );


    useEffect(() => {
        const updateFutureRates = async () => {
          if (!plans || plans.length === 0) return;
      
          try {
            for (const plan of plans) {
              if (
                plan.isRenewal === "Yes" &&
                plan.planRateType === "UnitBased" &&
                plan.currentRateStartDate !== undefined &&
                plan.currentRateEndDate !== undefined
              ) {
                const patchDocument = [
                  { op: "replace", path: "/futureRateStartDate", value: plan.currentRateStartDate },
                  { op: "replace", path: "/futureRateEndDate", value: plan.currentRateEndDate },
                ];
                await axios.patch(`${updateUrl}/${plan.planId}`, patchDocument);
              }
            }
          } catch (error) {
            console.error("Error updating future rates:", error);
          }
        };
      
        updateFutureRates();
      }, [plans, updateUrl]);
      

    const handleInputChange = (index, e) => {
        const { name, value } = e.target;
        validateField(name, value, index);

        const updatedPlans = [...plans];
        updatedPlans[index] = { ...updatedPlans[index], [name]: value };
        setPlans(updatedPlans);

        debouncedUpdate(name, value, updatedPlans[index].planId);
    };

    const handleSelectChange = (index, name, selectedOption) => {
        console.log(name)
        console.log(selectedOption)
        const value = selectedOption ? selectedOption.value : '';
        validateField(name, value, index);

        const updatedPlans = [...plans];
        updatedPlans[index] = { ...updatedPlans[index], [name]: value };
        setPlans(updatedPlans);

        // Check if the selected field is carrierName
        if (name === 'carrierName') {
            addCarrierNameToLS(value); // Call addCarrierNameToLS with the selected value
        }

        debouncedUpdate(name, value, updatedPlans[index].planId);

        // if(name === 'planRateType' && value == 'UnitBased'){
        //     if (coverageRatesRefs.current[index]) {
        //         alert('ref is ')
        //     coverageRatesRefs.current[index].handleRateTypeChange();
        //     }
        // }
    };

    const addCarrierNameToLS = (newCarrierName) => {
        const storedData = localStorage.getItem('carrierNames');
        const carrierNamesMap = storedData ? JSON.parse(storedData) : {};

        // Initialize the case ID if it doesn't exist
        if (!carrierNamesMap[caseId]) {
            carrierNamesMap[caseId] = [];
        }

        // Add the new carrier name if it doesn't already exist
        if (!carrierNamesMap[caseId].includes(newCarrierName)) {
            carrierNamesMap[caseId].push(newCarrierName);
            // Store the updated map in local storage
            localStorage.setItem('carrierNames', JSON.stringify(carrierNamesMap));
        }
    };

    const handleDateChange = (index, fieldName, date) => {
        if (date) {
            // Normalize the date to remove timezone issues
            const localDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    
            // Format the date as MM/dd/yyyy
            const formattedDate = localDate.toLocaleDateString('en-US', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
            });
    
            // Perform field validation
            validateField(fieldName, formattedDate, index);
    
            // Update the state with the formatted date
            const updatedPlans = [...plans];
            updatedPlans[index] = { ...updatedPlans[index], [fieldName]: formattedDate };
            setPlans(updatedPlans);
    
            // Send debounced update to backend
            debouncedUpdate(fieldName, formattedDate, updatedPlans[index].planId);
        } else {
            // Handle the case when the date is cleared (null)
            const updatedPlans = [...plans];
            updatedPlans[index] = { ...updatedPlans[index], [fieldName]: '' }; // Clear the field
            setPlans(updatedPlans);
    
            // Send debounced update with an empty value
            debouncedUpdate(fieldName, '', updatedPlans[index].planId);
        }
    };
    

    const debouncedRatesUpdate = useCallback(
        debounce(async (patchDocument, planId) => {
            try {
                const url = `${updateUrl}/${planId}`;
                await axios.patch(url, patchDocument);
            } catch (error) {
                console.error('Error updating field:', error);
                onError(error);
            }
        }, 500),
        [updateUrl, onError, validationErrors]
    );

    const handleRadioChange = (index, fieldName, e) => {
        
        const { name, value } = e.target;
        validateField(fieldName, value, index);
        
        const updatedPlans = [...plans];
        updatedPlans[index] = { ...updatedPlans[index], [fieldName]: value };
        setPlans(updatedPlans);

        let patchDocument = [{ op: 'replace', path: `/${fieldName}`, value: value }];
        
        debouncedUpdate(fieldName, value, updatedPlans[index].planId);
    };

    

    const handleToggleChange = (index, e, property) => {
        const { checked } = e.target;
        const value = checked ? 'true' : 'false';
        const updatedPlans = [...plans];
        const updatedPlan = { ...updatedPlans[index] };

        updatedPlan[property] = value;

        // const addOneYear = (dateStr) => {
        //     const date = new Date(dateStr);
        //     if (!isNaN(date.getTime())) {
        //         date.setFullYear(date.getFullYear() + 1);
        //     }
        //     return date;
        // };

        const addOneYear = (dateStr) => {
            const [month, day, year] = dateStr.split('-').map(Number);
            const date = new Date(year, month - 1, day); // month is 0-indexed

            if (!isNaN(date.getTime())) {
                date.setFullYear(date.getFullYear() + 1);
            }

            // Format the output back to MM-DD-YYYY
            const newMonth = String(date.getMonth() + 1).padStart(2, '0'); // 0-indexed, so +1
            const newDay = String(date.getDate()).padStart(2, '0');
            const newYear = date.getFullYear();

            return `${newMonth}-${newDay}-${newYear}`;
        };


        let patchDocument = [{ op: 'replace', path: `/${property}`, value: value }];


        if (property === 'isRatesChanging' && value === 'false') {

            if (updatedPlan.currentRateStartDate) {
                // updatedPlan.futureRateStartDate = addOneYear(updatedPlan.currentRateStartDate).toISOString().split('T')[0];
                updatedPlan.futureRateStartDate = addOneYear(updatedPlan.currentRateStartDate)
                patchDocument.push({ op: 'replace', path: `/futureRateStartDate`, value: updatedPlan.futureRateStartDate });
            }


            if (updatedPlan.currentRateEndDate) {
                // updatedPlan.futureRateEndDate = addOneYear(updatedPlan.currentRateEndDate).toISOString().split('T')[0];
                updatedPlan.futureRateEndDate = addOneYear(updatedPlan.currentRateEndDate)
                patchDocument.push({ op: 'replace', path: `/futureRateEndDate`, value: updatedPlan.futureRateEndDate });
            }


            if (coverageRatesRefs.current[index]) {
                coverageRatesRefs.current[index].handleRatesToggleChange();
            }
        } else if(property === 'isRatesChanging' && value === 'true') { // added to pass rates to child for true condition
            if (coverageRatesRefs.current[index]) {
                coverageRatesRefs.current[index].handleRatesToggleChange();
            }
        }



        const updatedErrors = Array.isArray(validationErrors) ? validationErrors.map((error, index) => {
            const updatedError = { ...error };
            
            
            if (property === 'isRatesChanging' && value === 'false' && updatedError.futureRateStartDate) {
              delete updatedError.futureRateStartDate;
            }

            if (property === 'isRatesChanging' && value === 'false' && updatedError.futureRateEndDate) {
                delete updatedError.futureRateEndDate;
              }
        
            
            if (Object.keys(updatedError).length === 0) {
              return null; 
            }
        
            return updatedError;
          }).filter(Boolean): []; 
        
          
          setValidationErrors(updatedErrors);


        updatedPlans[index] = updatedPlan;
        setPlans(updatedPlans);


        debouncedRatesUpdate(patchDocument, updatedPlan.planId);
    };


    const handleBoolToggleChange = (index, e, property) => {
        const { checked } = e.target;
        const value = checked;
        const updatedPlans = [...plans];
        const updatedPlan = { ...updatedPlans[index] };

        updatedPlan[property] = value;


        let patchDocument = [{ op: 'replace', path: `/${property}`, value: value }];

        updatedPlans[index] = updatedPlan;
        setPlans(updatedPlans);


        debouncedRatesUpdate(patchDocument, updatedPlan.planId);
    };













    const validateAll = () => {
        let allValid = true;
        let updatedErrors = { ...validationErrors };

        plans.forEach((plan, index) => {
            // Validate form fields
            formFields.forEach(field => {
                const fieldError = validateField(field.name, plan[field.name], index, false);
                if (fieldError) {
                    allValid = false;
                    updatedErrors = {
                        ...updatedErrors,
                        [index]: {
                            ...updatedErrors[index],
                            ...fieldError
                        }
                    };
                }
            });

            // Validate coverage rates for each plan
            if (coverageRatesRefs.current[index]) {
                const coverageRatesValid = coverageRatesRefs.current[index].validateAll();
                if (!coverageRatesValid) {
                    allValid = false;
                }
            }
        });

        

        setValidationErrors(updatedErrors);
        return allValid;
    };


    const validateField = (name, value, index, updateState = true) => {
        let errors = { ...validationErrors };
        let fieldError = null;

        switch (name) {
            case 'planName':
                if (!value && plans[index].isTerminating !== 'true') {
                    fieldError = { [name]: 'Plan name is required.' };
                } else {

                    if (errors[index]) delete errors[index][name];
                }
                break;
            case 'planRenewalDate':
                if (!value && plans[index].isTerminating !== 'true') {
                    fieldError = { [name]: 'Plan renewal date is required.' };
                } else {

                    if (errors[index]) delete errors[index][name];
                }
                break;
            case 'insuranceType':
                if (!value && plans[index].isTerminating !== 'true') {
                    fieldError = { [name]: 'Insurance type date is required.' };
                } else {

                    if (errors[index]) delete errors[index][name];
                }
                break;
            // case 'incorporationState':
            //     if (!value && (plans[index].isRenewal !== 'true' && plans[index].isTerminating !== 'true')) {
            //         fieldError = { [name]: 'State of plan issuance is required.' };
            //     } else {

            //         if (errors[index]) delete errors[index][name];
            //     }
            //     break;
            case 'carrierName':
                if (!value && plans[index].isTerminating !== 'true') {
                    fieldError = { [name]: 'Carrier name required.' };
                } else {

                    if (errors[index]) delete errors[index][name];
                }
                break;

            case 'planRule':
                if (!value && plans[index].isTerminating !== 'true') {
                    fieldError = { [name]: 'Plan rule required.' };
                } else {

                    if (errors[index]) delete errors[index][name];
                }
                break;
            case 'planRateType':
                if (!value && plans[index].isTerminating !== 'true') {
                    fieldError = { [name]: 'Plan Rate type is required.' };
                } else {

                    if (errors[index]) delete errors[index][name];
                }
                break;
            // case 'currentRateStartDate':
            //     if (!value && plans[index].isRenewal === 'No' && plans[index].planRateType === "UnitBased" && plans[index].isTerminating !== 'true') {
            //         fieldError = { [name]: 'Current Rate start date is required.' };
            //     } else {

            //         if (errors[index]) delete errors[index][name];
            //     }
            //     break;
            case 'futureRateStartDate':
                if (!value && plans[index].planRateType === "Composite"  && plans[index].isRatesChanging === 'true' && plans[index].isTerminating !== 'true') {
                    fieldError = { [name]: 'Future Rate start date is required.' };
                } else {

                    if (errors[index]) delete errors[index][name];
                }
                break;
            // case 'currentRateEndDate':
            //     if (!value && plans[index].isRenewal === 'No' &&  plans[index].planRateType === "UnitBased" && plans[index].isTerminating !== 'true') {
            //         fieldError = { [name]: 'Current Rate end date is required.' };
            //     } else {

            //         if (errors[index]) delete errors[index][name];
            //     }
            //     break;
            case 'futureRateEndDate':
                if (!value && plans[index].planRateType === "Composite"  && plans[index].isRatesChanging === 'true' && plans[index].isTerminating !== 'true') {
                    fieldError = { [name]: 'Future Rate end date is required.' };
                } else {

                    if (errors[index]) delete errors[index][name];
                }
                break;
            case 'planTerminationDate':
                if (!value && ((plans[index].isRenewal === 'true' || plans[index].isRenewal === 'Yes') && plans[index].isTerminating === 'true')) {
                    fieldError = { [name]: 'Plan termination date is required.' };
                } else {

                    if (errors[index]) delete errors[index][name];
                }
                break;
            default:
                break;
        }

        if ((plans[index].planRateType === "Age/Banded" || plans[index].planRateType === "Unit + Age/Gender") && plans[index].isTerminating !== 'true') {
            const hasFiles = files.filter(file => file.plan === planName && file.fileCategory === 'Age/Gender Banded Rates' && file.meta === plans[index].planId).length > 0;
            if (!hasFiles) {
                fieldError = { ['fileUpload']: 'Age/Gender file must be uploaded for this plan.' };
                //alert(`upload file for ${planName} - ${index}`)
            } else {
                if (errors[index]) delete errors[index]['fileUpload'];
            }
        }



        if (updateState && fieldError) {
            errors[index] = {
                ...errors[index],
                ...fieldError
            };
            setValidationErrors(errors);
        }

        return fieldError;
    };





    const handleDeletePlan = async (index) => {
        alertconfirmation(
            `Do you want to delete this specific ${planName} Plan ?`,
            "Confirmation",
            async () => {
                try {
                    const planId = plans[index].planId;
                    // Include withCredentials: true to send credentials with the request
                    await axios.delete(`${deleteUrl}/${planId}`);
                    const updatedPlans = plans.filter((_, i) => i !== index);
                    setPlans(updatedPlans);
                } catch (error) {
                    console.error('Error deleting plan:', error);
                    onError(error);
                }
            }
        );
    };
    

    const handleAddPlan = async () => {
        try {
    
            // -----------------------------
            // DEFAULT VALUES FROM FIRST PLAN
            // -----------------------------
            const firstPlanCarrierName =
                plans.length > 0 ? plans[0].carrierName : '';
    
            const firstPlanIncorporationState =
                plans.length > 0 ? plans[0].incorporationState : '';
    
            const firstPlanPlanRenewalDate =
                plans.length > 0 ? plans[0].planRenewalDate : '';
    
            const firstPlanInsuranceType =
                plans.length > 0 ? plans[0].insuranceType : '';
    
            // -----------------------------
            // CREATE NEW PLAN
            // -----------------------------
            const randomId = uuidv4();
    
            const newPlanId = `${caseId}_${randomId}`;
    
            const newPlan = {
                ...initialFormValues,
                planId: newPlanId,
                carrierName: firstPlanCarrierName,
                incorporationState: firstPlanIncorporationState,
                planrenewalDate: firstPlanPlanRenewalDate,
                insuranceType: firstPlanInsuranceType,
                isRenewal: 'false',
                caseId: caseId
            };
    
            const response = await axios.post(addUrl, newPlan);
    
            // -----------------------------
            // CREATE COVERAGE RATES
            // -----------------------------
            const coverageRandomId1 = uuidv4();
    
            const newCoverageRate1 = {
                id: `${caseId}_${coverageRandomId1}`,
                [`${planName}PlanId`]: newPlanId
            };
    
            await axios.post(
                `${config.API_URL}/${planName}CoverageRates`,
                newCoverageRate1
            );
    
            const coverageRandomId2 = uuidv4();
    
            const newCoverageRate2 = {
                id: `${caseId}_${coverageRandomId2}`,
                [`${planName}PlanId`]: newPlanId
            };
    
            await axios.post(
                `${config.API_URL}/${planName}CoverageRates`,
                newCoverageRate2
            );
    
            // -----------------------------
            // COPY COBRA GROUPS
            // -----------------------------
            // Copy only from existing selected groups
            // Prevent duplicate copying across plans
            const sourcePlanId = plans.length > 0
                ? plans[0].planId
                : null;
    
            const existingSelectedGroups = rightDivisions.filter(
                x =>
                    x.isSelected === true &&
                    x.planId === sourcePlanId
            );
    
            // Create DirectBillGroups for newly added plan
            for (const division of existingSelectedGroups) {
    
                const newGroup = {
                    id: `${caseId}_${uuidv4()}`,
                    employeeGroupId: division.employeeGroupId || null,
                    employeeGroupName: division.employeeGroupName,
                    planId: newPlanId,
                    isSelected: true,
                    determinesBenefitEligibility:
                        division.determinesBenefitEligibility || false,
                    createdAt: new Date().toISOString(),
                    createdBy: userName,
                    updatedAt: null,
                    updatedBy: null,
                    isCurrent: true,
                    caseId: caseId
                };
    
                await axios.post(
                    `${config.API_URL}/DirectBillGroups`,
                    newGroup
                );
            }
    
            // -----------------------------
            // REFRESH GROUPS
            // -----------------------------
            await fetchDirectBillGroups();
    
            // -----------------------------
            // UPDATE STATE
            // -----------------------------
            setPlans(prev => [...prev, response.data]);
    
        } catch (error) {
    
            console.error('Error adding new plan:', error);
    
            onError(error);
        }
    };





    const toggleSelection = (divisionId, side) => {
        if (side === 'left') {
            setSelectedLeft(prev =>
                prev.includes(divisionId)
                    ? prev.filter(item => item !== divisionId)
                    : [...prev, divisionId]
            );
        } else {
            setSelectedRight(prev =>
                prev.includes(divisionId)
                    ? prev.filter(item => item !== divisionId)
                    : [...prev, divisionId]
            );
        }
    };

    const moveLeftToRight = async (planId) => {
        await Promise.all(
            selectedLeft.map(async divisionId => {
                const division = leftDivisions.find(div => div.id === divisionId);

                if (division) {

                    const matchingRightDivision = rightDivisions.find(
                        rightDiv => rightDiv.employeeGroupName === division.employeeGroupName && rightDiv.planId === planId
                    );

                    if (matchingRightDivision) {

                        await patchDivisionSelection(matchingRightDivision.id, true);


                        setRightDivisions(prev =>
                            prev.map(rightDiv =>
                                rightDiv.id === matchingRightDivision.id
                                    ? { ...matchingRightDivision, isSelected: true }
                                    : rightDiv
                            )
                        );
                    } else {

                        const groupId = uuidv4();


                        const newDivision = {
                            id: caseId+"_"+groupId,
                            employeeGroupName: division.employeeGroupName,
                            planId: planId,
                            isSelected: true,
                            caseId: division.caseId
                        };


                        const postedDivision = await postNewDivision(newDivision);


                        setRightDivisions(prev => [...prev, postedDivision]);
                    }
                }
            })
        );


        setLeftDivisions(prev => prev.filter(div => !selectedLeft.includes(div.id)));


        setSelectedLeft([]);
    };





    const moveRightToLeft = async (planId) => {

        await Promise.all(
            selectedRight.map(async divisionId => {
                const division = rightDivisions.find(div => div.planId === planId && div.id === divisionId);
                if (division) {
                    await patchDivisionSelection(division.id, false);
                }
            })
        );


        const movedDivisions = rightDivisions.filter(div => selectedRight.includes(div.id));
        setLeftDivisions(prev => [...prev, ...movedDivisions]);
        setRightDivisions(prev => prev.filter(div => !selectedRight.includes(div.id)));
        setSelectedRight([]);
    };


    const renderDivisions = (divisions, selected, side) =>
        divisions.map((division) => (
            <p
                key={division.id}
                onClick={() => toggleSelection(division.id, side)}
                className={selected.includes(division.id) ? 'selected' : ''}
                style={{ cursor: 'pointer' }}
            >
                {`${division.employeeGroupName}`}
            </p>
        ));

    const postNewDivision = async (newDivision) => {
        // Example POST request implementation
        const response = await fetch(`${config.API_URL}/DirectBillGroups`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(newDivision)
        });
        return response.json();
    };


    const patchDivisionSelection = async (divisionId, isSelected) => {
        try {
            const response = await fetch(`${config.API_URL}/DirectBillGroups/${divisionId}`, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify([{ op: 'replace', path: '/isSelected', value: isSelected }]), // JSON Patch format
            });

            if (!response.ok) {
                throw new Error(`Error updating division ${divisionId}: ${response.statusText}`);
            }
        } catch (error) {
            console.error("Failed to update the division selection:", error);
        }
    };


    const customStyles = (hasError) => ({
        control: (provided) => ({
            ...provided,
            borderColor: hasError ? '#dc3545' : provided.borderColor,
            '&:hover': {
                borderColor: hasError ? '#dc3545' : provided.borderColor,
            },
            boxShadow: hasError ? '0 0 10px rgba(220, 53, 69, 0.5)' : provided.boxShadow,
        }),
    });

    useImperativeHandle(ref, () => ({
        getPlans: () => plans,
        validateAll
    }));

    //const isDisabled = renewalCase?.directBillSubmissionStatus === 'Submitted' || isDisableForUsers;
    const isDisabled = isDisableForUsers;


    if (loading) return <Skeleton />;
    if (error) return <div>{error}</div>;

    return (
        <div>
            <div className="col-lg-12 mb-3">
                <div className="collapsible">
                    <div className="collapsible-btn plan-collapsible-btn mx-auto d-block" onClick={plans.length > 0 ? toggleCollapsible : undefined}>
                        {planName} Plan Information
                        {plans.length === 0 && planName !== "FSA" && (
                            <button
                                type="button"
                                className="btn btn-success btn-sm sm-btns my-1 float-end"
                                disabled={isDisabled}
                                onClick={handleAddPlan}
                            >
                                Add {planName} Plan
                            </button>
                        )}


                    </div>
                    {isOpen && (
                        <div className="collapsible-content mt-3">
                            <div className="container-fluid">
                                <div className="row session">
                                    {plans.map((plan, index) => (


                                        <div key={index}>


                                            <div className="plan-repeater" id={`planContainer-${index}`}>
                                                <div className="card mb-3">
                                                    <div className="card-body">
                                                        <div className="row mb-3">

                                                            {(plan.isRenewal === "true" || plan.isRenewal === "Yes") && (
                                                                <div>
                                                                    <div className="row mb-3">
                                                                        <div className="d-flex">
                                                                            <strong>{plan.carrierName} - {plan.planName}</strong>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-lg-12 d-flex mb-2">
                                                                        <em>If your carrier, plan, or rate structure is changing, please terminate this plan and add a new one.</em>
                                                                    </div>

                                                                    <div className="row mb-3">
                                                                        <div className="col-lg-3">
                                                                            <div className="form-check form-switch form-toggle">
                                                                                <label className="form-check-label">
                                                                                    Is this plan terminating?
                                                                                </label>
                                                                                <input type="checkbox" className="form-check-input form-check-input-toggel toggle-input-switch"
                                                                                    checked={plan.isTerminating === 'true'}
                                                                                    onChange={(e) => handleToggleChange(index, e, 'isTerminating')} role="switch" value="true"
                                                                                    disabled={isDisabled} />
                                                                            </div>
                                                                        </div>
                                                                        {plan.isTerminating === "true" && (
                                                                            <div className="col-lg-3 mb-2 termination_date" id="termination_date">
                                                                                <div className="d-flex">
                                                                                    <span className="input-group-text">
                                                                                        <i className="far fa-calendar-alt"></i>
                                                                                    </span>
                                                                                    <OverlayTrigger
                                                                                        placement="top"
                                                                                        overlay={<Tooltip id="planTerminationDate-tooltip">Plan Termination Date</Tooltip>}
                                                                                    >
                                                                                        <div>
                                                                                            <DatePicker
                                                                                                className={`form-control ${validationErrors[index] && validationErrors[index].planTerminationDate ? 'is-invalid' : ''}`}
                                                                                                selected={plan.planTerminationDate || ''}
                                                                                                onChange={(date) => handleDateChange(index, 'planTerminationDate', date)}
                                                                                                placeholderText="Plan Termination Date" dateFormat="MM/dd/yyyy" disabled={isDisabled}
                                                                                            />
                                                                                        </div>
                                                                                    </OverlayTrigger>

                                                                                </div>
                                                                                {validationErrors[index] && validationErrors[index].planTerminationDate && (
                                                                                    <div className="invalid-feedback d-block">
                                                                                        {validationErrors[index].planTerminationDate}
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            )}
                                                            {plan.isTerminating !== "true" && (
                                                                <div>
                                                                    <div className='row'>
                                                                        {formFields
                                                                            .filter(field =>
                                                                                !(
                                                                                    (plan.isRenewal === "true" || plan.isRenewal === "Yes") &&
                                                                                    ['incorporationState', 'carrierName', 'planName'].includes(field.name)
                                                                                ) &&
                                                                                !['planTerminationDate', 'planRule', 'planRateType', 'currentRateStartDate', 'currentRateEndDate', 'futureRateStartDate', 'futureRateEndDate']
                                                                                    .includes(field.name)
                                                                            )
                                                                            .map((field, fieldIndex) => (
                                                                                <div key={fieldIndex} className="col-lg-3">
                                                                                    <div className="input-group mb-2">
                                                                                        {field.type === 'select' ? (
                                                                                            <OverlayTrigger
                                                                                                placement="top"
                                                                                                overlay={<Tooltip id={`${field.name}-tooltip`}>{field.tooltip}</Tooltip>}
                                                                                            >
                                                                                                <div className="w-100">
                                                                                                    <Select
                                                                                                        className={`flex-grow-1 ${field.className} ${validationErrors[index] && validationErrors[index][field.name] ? 'is-invalid' : ''}`}
                                                                                                        title={field.title}
                                                                                                        name={field.name}
                                                                                                        options={localSelectOptions[field.name]}
                                                                                                        value={localSelectOptions[field.name]?.find(option => option.value === plan[field.name])}
                                                                                                        placeholder={field.placeholder}
                                                                                                        onChange={(selectedOption) => handleSelectChange(index, field.name, selectedOption)}
                                                                                                        isDisabled={(plan.isRenewal === "true" || plan.isRenewal === "Yes") && field.name === 'carrierName' || isDisabled}
                                                                                                        styles={customStyles(validationErrors[index] && validationErrors[index][field.name])}
                                                                                                    />
                                                                                                </div>
                                                                                            </OverlayTrigger>
                                                                                        ) : field.type === 'date' ? (
                                                                                            <OverlayTrigger
                                                                                                placement="top"
                                                                                                overlay={<Tooltip id={`${field.name}-tooltip`}>{field.tooltip}</Tooltip>}
                                                                                            >
                                                                                                <div className="w-100">
                                                                                                    <DatePicker
                                                                                                        className={`form-control ${validationErrors[index] && validationErrors[index][field.name] ? 'is-invalid' : ''}`}
                                                                                                        selected={plan[field.name]}
                                                                                                        onChange={(date) => handleDateChange(index, field.name, date)}
                                                                                                        placeholderText={field.placeholder}
                                                                                                        dateFormat="MM/dd/yyyy"
                                                                                                        disabled={isDisabled}
                                                                                                    />
                                                                                                </div>
                                                                                            </OverlayTrigger>
                                                                                        ) : (
                                                                                            <OverlayTrigger
                                                                                                placement="top"
                                                                                                overlay={<Tooltip id={`${field.name}-tooltip`}>{field.tooltip}</Tooltip>}
                                                                                            >
                                                                                                <input
                                                                                                    className={`form-control ${field.className} ${validationErrors[index] && validationErrors[index][field.name] ? 'is-invalid' : ''} ${(plan.isRenewal === "true" || plan.isRenewal === "Yes") && field.name === 'planName' ? 'read-only-select-style' : ''}`}
                                                                                                    title={field.title}
                                                                                                    type={field.type}
                                                                                                    name={field.name}
                                                                                                    placeholder={field.placeholder}
                                                                                                    value={plan[field.name] || ''}
                                                                                                    onChange={(e) => handleInputChange(index, e)}
                                                                                                    readOnly={(plan.isRenewal === "true" || plan.isRenewal === "Yes") && field.name === 'planName'}
                                                                                                    disabled={isDisabled}
                                                                                                    maxLength={field.name === 'planName' ? 50 : undefined}
                                                                                                />
                                                                                            </OverlayTrigger>
                                                                                        )}
                                                                                        {validationErrors[index] && validationErrors[index][field.name] && (
                                                                                            <div className="invalid-feedback d-block">
                                                                                                {validationErrors[index][field.name]}
                                                                                            </div>
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                            ))
                                                                        }

                                                                    </div>
                                                                    {rightDivisions.filter(division => (division.planId === plan.planId)).length > 0 && (
                                                                        <>
                                                                            <div className="col-lg-12 mb-3">
                                                                                <div className="form-check form-switch form-toggle">
                                                                                    <label className="form-check-label">
                                                                                        {(plan.isRenewal === "true" || plan.isRenewal === "Yes") ? 'This plan is available only to a specific division' : 'Is this plan available only to a specific division(s)?'}
                                                                                    </label>
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        className="form-check-input form-check-input-toggel toggle-input-switch"
                                                                                        role="switch"
                                                                                        checked={plan.isDivisionSpecific === 'true'}
                                                                                        onChange={(e) => handleToggleChange(index, e, 'isDivisionSpecific')}
                                                                                        id={`plan_IsDivisionSpecific-${index}`}
                                                                                        name="isDivisionSpecific"
                                                                                        disabled={isDisabled}
                                                                                    />
                                                                                </div>
                                                                            </div>

                                                                            <div className={`row mb-3 divisionsContainer ${plan.isDivisionSpecific === 'true' ? '' : 'd-none'}`} id={`planDivision_${index}`}>
                                                                                <div className="expensesContainer container">
                                                                                <div className='block-container'>
                                                                                <label className='ms-2'><strong>Available</strong></label>
                                                                                <div className="block left-block">
                                                                                        {renderDivisions(
                                                                                            // Combine leftDivisions and rightDivisions where isSelected is false
                                                                                            [...leftDivisions,
                                                                                            ...rightDivisions.filter(rightDivision => rightDivision.isSelected === false && rightDivision.planId === plan.planId)
                                                                                            ]
                                                                                                .filter(division => division.employeeGroupName) // Ensure employeeGroupName exists
                                                                                                // Ensure unique employeeGroupName
                                                                                                .filter((division, index, self) =>
                                                                                                    index === self.findIndex(d => d.employeeGroupName === division.employeeGroupName)
                                                                                                )
                                                                                                // Exclude employeeGroupName already in rightDivisions with isSelected true
                                                                                                .filter(division =>
                                                                                                    !rightDivisions.some(rightDivision =>
                                                                                                        rightDivision.employeeGroupName === division.employeeGroupName &&
                                                                                                        rightDivision.isSelected === true &&
                                                                                                        rightDivision.planId === plan.planId)
                                                                                                ),
                                                                                            selectedLeft,
                                                                                            'left'
                                                                                        )}

                                                                                    </div>
                                                                                </div>
                                                                                    

                                                                                    <div className="arrow-container">
                                                                                        <i
                                                                                            className="arrow fas fa-arrow-right right-arrow"
                                                                                            onClick={() => moveLeftToRight(plan.planId)}
                                                                                        ></i>
                                                                                        <i
                                                                                            className="arrow fas fa-arrow-left left-arrow"
                                                                                            onClick={() => moveRightToLeft(plan.planId)}
                                                                                        ></i>
                                                                                    </div>
                                                                                    <div className='block-container'>
                                                                                    <label className='ms-3'><strong>Selected</strong></label>
                                                                                    <div className="block right-block">
                                                                                        {renderDivisions(
                                                                                            rightDivisions.filter(division =>
                                                                                                division.planId === plan.planId && division.isSelected === true
                                                                                            ),
                                                                                            selectedRight,
                                                                                            'right'
                                                                                        )}
                                                                                    </div>
                                                                                    </div>
                                                                                    
                                                                                </div>
                                                                            </div>


                                                                        </>
                                                                    )}


                                                                    <div className="row pt-3 mb-3">
                                                                        <div className="col-lg-12">
                                                                            <div className="form-check form-switch form-toggle">
                                                                                <label className="form-check-label">


                                                                                Do you wish to charge an additional 50% of the premium for disability extension?

                                                                                </label>
                                                                                <input
                                                                                    type="checkbox"
                                                                                    className="form-check-input form-check-input-toggel toggle-input-switch"
                                                                                    role="switch"
                                                                                    checked={plan.isDisabilityExtension === 'true'}
                                                                                    onChange={(e) => handleToggleChange(index, e, 'isDisabilityExtension')}
                                                                                    id="plan_IsDisabilityExtension"
                                                                                    name="isDisabilityExtension"
                                                                                    disabled={isDisabled}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div className="row mb-3">
                                                                        <div className="col-lg-6">
                                                                            <div className="input-group mb-2">
                                                                                <OverlayTrigger
                                                                                    placement="top"
                                                                                    overlay={<Tooltip id="plan-rule-tooltip">Plan Coverage Termination Rule</Tooltip>}
                                                                                >
                                                                                    <div className="w-100">
                                                                                        <Select
                                                                                            classNamePrefix="react-select"
                                                                                            className={`flex-grow-1 `}  // Ensures the Select takes up the remaining space in the input group
                                                                                            title="Plan Coverage Termination Rule"
                                                                                            name="planRule"
                                                                                            options={localSelectOptions.planRule}
                                                                                            value={localSelectOptions?.planRule?.find(option => option.value === plan.planRule)}
                                                                                            placeholder="Plan Coverage Termination Rule"
                                                                                            onChange={(selectedOption) => handleSelectChange(index, 'planRule', selectedOption)}
                                                                                            styles={customStyles(validationErrors[index] && validationErrors[index].planRule)}
                                                                                            isDisabled={isDisabled}
                                                                                        />
                                                                                    </div>
                                                                                </OverlayTrigger>

                                                                                <p className='mt-1 ms-2' onClick={planRulebox} style={{ color: '#2367a4', cursor: 'pointer' }}><strong>Coverage Termination Rule Definitions</strong></p>

                                                                            </div>
                                                                            {validationErrors[index] && validationErrors[index].planRule && (
                                                                                <div className="invalid-feedback d-block">
                                                                                    {validationErrors[index].planRule}
                                                                                </div>
                                                                            )}
                                                                        </div>


                                                                        <div className="col-lg-6">
                                                                            <div className="input-group mb-2">
                                                                                <OverlayTrigger
                                                                                    placement="top"
                                                                                    overlay={<Tooltip id="plan-rate-type-tooltip">Plan Rate Type</Tooltip>}
                                                                                >
                                                                                    <div className="w-100">
                                                                                        <Select
                                                                                            className={`flex-grow-1 `}
                                                                                            title="Plan Rate Type"
                                                                                            name="planRateType"
                                                                                            options={localSelectOptions.planRateType}
                                                                                            value={localSelectOptions?.planRateType?.find(option => option.value === plan.planRateType)}
                                                                                            placeholder="Plan Rate Type"
                                                                                            onChange={(selectedOption) => handleSelectChange(index, 'planRateType', selectedOption)}
                                                                                            isDisabled={(plan.isRenewal === "true" || plan.isRenewal === "Yes") || isDisabled}
                                                                                            styles={customStyles(validationErrors[index] && validationErrors[index].planRateType)}
                                                                                        />
                                                                                    </div>
                                                                                </OverlayTrigger>
                                                                            </div>
                                                                            {validationErrors[index] && validationErrors[index].planRateType && (
                                                                                <div className="invalid-feedback d-block">
                                                                                    {validationErrors[index].planRateType}
                                                                                </div>
                                                                            )}
                                                                        </div>

                                                                    </div>


                                                                    {(plan.planRateType === "Composite" || plan.planRateType === "UnitBased") && (
                                                                        <div>
                                                                            {(plan.planRateType !== "UnitBased" && (plan.isRenewal === "true" || plan.isRenewal === "Yes")) && (
                                                                                <div className="row mb-3">
                                                                                    <div className="col-lg-12">
                                                                                        <div className="form-check form-switch form-toggle">
                                                                                            <label className="form-check-label">
                                                                                            Are rates and/or coverage level changing?
                                                                                            </label>
                                                                                            <input
                                                                                                type="checkbox"
                                                                                                className="form-check-input form-check-input-toggel toggle-input-switch"
                                                                                                role="switch"
                                                                                                checked={plan.isRatesChanging === 'true'}
                                                                                                onChange={(e) => handleToggleChange(index, e, 'isRatesChanging')}
                                                                                                id="plan_IsRatesChanging"
                                                                                                name="isRatesChanging"
                                                                                                disabled={isDisabled}
                                                                                            />

                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            )}
                                                                            <div id={`rateinformation_${index}`} className="mb-3">
                                                                                <h5 className="card-title">Rate Information</h5>
                                                                                {(plan.planRateType === "Unit + Age/Gender" || plan.planRateType === "UnitBased") && (
                                                                                    <div className="d-flex mb-2">
                                                                                        Dollar per Unit - 1000
                                                                                    </div>
                                                                                )}
                                                                                <div className="row">
                                                                                    <div className="col-lg-3"></div>
                                                                                    {(plan.planRateType !== "UnitBased" && (plan.isRenewal === "true" || plan.isRenewal === "Yes")) ? (
                                                                                        <div className="col-lg-3">
                                                                                            Current 100% Monthly Premium <br></br> (exclude 2% admin fee)

                                                                                        </div>
                                                                                    ) : (plan.planRateType === "UnitBased" && (plan.isRenewal === "true" || plan.isRenewal === "Yes")) ? (
                                                                                        <div className="col-lg-3">
                                                                                            Premiums per Unit
                                                                                        </div>
                                                                                    ) : ('')}


                                                                                    {(plan.planRateType !== "UnitBased" && (plan.isRenewal === "true" || plan.isRenewal === "Yes")) ? (
                                                                                        <div className="col-lg-3">
                                                                                            Future 100% Monthly Premium <br /> (exclude 2% admin fee)
                                                                                        </div>
                                                                                    ) : ((plan.isRenewal !== "true" && plan.isRenewal !== "Yes") ? (
                                                                                        <div className="col-lg-3">
                                                                                            {plan.planRateType === "UnitBased" ? 'Premiums per Units' : (
                                                                                                <>
                                                                                                    100% Monthly Premium
                                                                                                    <br />
                                                                                                    (exclude 2% admin fee)
                                                                                                </>
                                                                                            )}
                                                                                        </div>
                                                                                    ) : (''))}



                                                                                </div>

                                                                                <div className="row mb-2">
                                                                                    <div className="col-lg-3"></div>
                                                                                    {(plan.isRenewal === "true" || plan.isRenewal === "Yes") && (
                                                                                        <div className="col-lg-3">
                                                                                            <div className="d-flex">
                                                                                                <span className="input-group-text">
                                                                                                    <i className="far fa-calendar-alt"></i>
                                                                                                </span>
                                                                                                <DatePicker
                                                                                                    className={`form-control  ${validationErrors[index] && validationErrors[index].currentRateStartDate ? 'is-invalid' : ''}`}
                                                                                                    selected={plan.currentRateStartDate || ''}
                                                                                                    onChange={(date) => handleDateChange(index, 'currentRateStartDate', date)}
                                                                                                    placeholderText="Current Rate Start Date"
                                                                                                    disabled={isDisabled || ((plan.isRenewal === "true" || plan.isRenewal === "Yes") && plan.planRateType !== "UnitBased")}
                                                                                                />
                                                                                            </div>
                                                                                            {validationErrors[index] && validationErrors[index].currentRateStartDate && (
                                                                                                <div className="invalid-feedback d-block">
                                                                                                    {validationErrors[index].currentRateStartDate}
                                                                                                </div>
                                                                                            )}
                                                                                        </div>

                                                                                    )}

                                                                                    {(plan.planRateType !== "UnitBased" && (plan.isRenewal === "true" || plan.isRenewal === "Yes")) ? (

                                                                                        <div className="col-lg-3">
                                                                                            <div className="d-flex">
                                                                                                <span className="input-group-text">
                                                                                                    <i className="far fa-calendar-alt"></i>
                                                                                                </span>
                                                                                                <DatePicker
                                                                                                    className={`form-control ${validationErrors[index] && validationErrors[index].futureRateStartDate ? 'is-invalid' : ''}`}
                                                                                                    selected={
                                                                                                        plan.isRatesChanging === 'true'
                                                                                                            ? (plan.futureRateStartDate ? new Date(plan.futureRateStartDate) : null)
                                                                                                            : (plan.currentRateStartDate
                                                                                                                ? new Date(new Date(plan.currentRateStartDate).setFullYear(new Date(plan.currentRateStartDate).getFullYear() + 1))
                                                                                                                : null)
                                                                                                    }
                                                                                                    onChange={(date) => handleDateChange(index, 'futureRateStartDate', date)}
                                                                                                    placeholderText="Future Rate Start Date"
                                                                                                    disabled={isDisabled || ((plan.isRenewal === "true" || plan.isRenewal === "Yes") && plan.isRatesChanging === 'false')}
                                                                                                    minDate={plan.currentRateStartDate ? new Date(plan.currentRateStartDate) : null}
                                                                                                />
                                                                                            </div>
                                                                                            {validationErrors[index] && validationErrors[index].futureRateStartDate && (
                                                                                                <div className="invalid-feedback d-block">
                                                                                                    {validationErrors[index].futureRateStartDate}
                                                                                                </div>
                                                                                            )}
                                                                                        </div>
                                                                                    ) : ((plan.isRenewal !== "true" && plan.isRenewal !== "Yes") ? (
                                                                                        <div className="col-lg-3">
                                                                                            <div className="d-flex">
                                                                                                <span className="input-group-text">
                                                                                                    <i className="far fa-calendar-alt"></i>
                                                                                                </span>
                                                                                                <DatePicker
                                                                                                    className={`form-control ${validationErrors[index] && validationErrors[index].futureRateStartDate ? 'is-invalid' : ''}`}
                                                                                                    selected={
                                                                                                        plan.isRatesChanging === 'true'
                                                                                                            ? (plan.futureRateStartDate ? new Date(plan.futureRateStartDate) : null)
                                                                                                            : (plan.currentRateStartDate
                                                                                                                ? new Date(new Date(plan.currentRateStartDate).setFullYear(new Date(plan.currentRateStartDate).getFullYear() + 1))
                                                                                                                : null)
                                                                                                    }
                                                                                                    onChange={(date) => handleDateChange(index, 'futureRateStartDate', date)}
                                                                                                    placeholderText="Future Rate Start Date"
                                                                                                    disabled={isDisabled || ((plan.isRenewal === "true" || plan.isRenewal === "Yes") && plan.isRatesChanging === 'false')}
                                                                                                    minDate={plan.currentRateStartDate ? new Date(plan.currentRateStartDate) : null}
                                                                                                />
                                                                                            </div>
                                                                                            {validationErrors[index] && validationErrors[index].futureRateStartDate && (
                                                                                                <div className="invalid-feedback d-block">
                                                                                                    {validationErrors[index].futureRateStartDate}
                                                                                                </div>
                                                                                            )}
                                                                                        </div>
                                                                                    ) : (''))}

                                                                                </div>

                                                                                <div className="row mb-2">
                                                                                    <div className="col-lg-3">{plan.planRateType === "UnitBased" ? 'Relationships' : 'Coverage Level'}</div>
                                                                                    {(plan.isRenewal === "true" || plan.isRenewal === "Yes") && (
                                                                                        <div className="col-lg-3">
                                                                                            <div className="d-flex mb-2">
                                                                                                <span className="input-group-text">
                                                                                                    <i className="far fa-calendar-alt"></i>
                                                                                                </span>
                                                                                                <DatePicker
                                                                                                    className={`form-control  ${validationErrors[index] && validationErrors[index].currentRateEndDate ? 'is-invalid' : ''}`}
                                                                                                    selected={plan.currentRateEndDate || ''}
                                                                                                    onChange={(date) => handleDateChange(index, 'currentRateEndDate', date)}
                                                                                                    placeholderText="Current Rate End Date"
                                                                                                    readOnly={(plan.isRenewal === "true" || plan.isRenewal === "Yes") && plan.planRateType !== "UnitBased"}
                                                                                                    disabled={isDisabled || ((plan.isRenewal === "true" || plan.isRenewal === "Yes") && plan.planRateType !== "UnitBased")}
                                                                                                    minDate={plan.currentRateStartDate ? new Date(plan.currentRateStartDate) : null}
                                                                                                />
                                                                                            </div>
                                                                                            {validationErrors[index] && validationErrors[index].currentRateEndDate && (
                                                                                                <div className="invalid-feedback d-block">
                                                                                                    {validationErrors[index].currentRateEndDate}
                                                                                                </div>
                                                                                            )}
                                                                                        </div>
                                                                                    )}
                                                                                    {(plan.planRateType !== "UnitBased" && (plan.isRenewal === "true" || plan.isRenewal === "Yes")) ? (
                                                                                        <div className="col-lg-3">
                                                                                            <div className="d-flex">
                                                                                                <span className="input-group-text">
                                                                                                    <i className="far fa-calendar-alt"></i>
                                                                                                </span>
                                                                                                <DatePicker
                                                                                                    className={`form-control ${validationErrors[index] && validationErrors[index].futureRateEndDate ? 'is-invalid' : ''}`}
                                                                                                    selected={
                                                                                                        plan.isRatesChanging === 'true'
                                                                                                            ? (plan.futureRateEndDate ? new Date(plan.futureRateEndDate) : null)
                                                                                                            : (plan.currentRateEndDate
                                                                                                                ? new Date(new Date(plan.currentRateEndDate).setFullYear(new Date(plan.currentRateEndDate).getFullYear() + 1))
                                                                                                                : null)
                                                                                                    }
                                                                                                    onChange={(date) => handleDateChange(index, 'futureRateEndDate', date)}
                                                                                                    placeholderText="Future Rate End Date"
                                                                                                    disabled={isDisabled || ((plan.isRenewal === "true" || plan.isRenewal === "Yes") && plan.isRatesChanging === 'false')}
                                                                                                    minDate={plan.futureRateStartDate ? new Date(plan.futureRateStartDate) : null}
                                                                                                />
                                                                                            </div>
                                                                                            {validationErrors[index] && validationErrors[index].futureRateEndDate && (
                                                                                                <div className="invalid-feedback d-block">
                                                                                                    {validationErrors[index].futureRateEndDate}
                                                                                                </div>
                                                                                            )}
                                                                                        </div>
                                                                                    ) : ((plan.isRenewal !== "true" && plan.isRenewal !== "Yes") ? (
                                                                                        <div className="col-lg-3">
                                                                                            <div className="d-flex">
                                                                                                <span className="input-group-text">
                                                                                                    <i className="far fa-calendar-alt"></i>
                                                                                                </span>
                                                                                                <DatePicker
                                                                                                    className={`form-control ${validationErrors[index] && validationErrors[index].futureRateEndDate ? 'is-invalid' : ''}`}
                                                                                                    selected={
                                                                                                        plan.isRatesChanging === 'true'
                                                                                                            ? (plan.futureRateEndDate ? new Date(plan.futureRateEndDate) : null)
                                                                                                            : (plan.currentRateEndDate
                                                                                                                ? new Date(new Date(plan.currentRateEndDate).setFullYear(new Date(plan.currentRateEndDate).getFullYear() + 1))
                                                                                                                : null)
                                                                                                    }
                                                                                                    onChange={(date) => handleDateChange(index, 'futureRateEndDate', date)}
                                                                                                    placeholderText="Future Rate End Date"
                                                                                                    disabled={isDisabled || ((plan.isRenewal === "true" || plan.isRenewal === "Yes") && plan.isRatesChanging === 'false')}
                                                                                                    minDate={plan.futureRateStartDate ? new Date(plan.futureRateStartDate) : null}
                                                                                                />
                                                                                            </div>
                                                                                            {validationErrors[index] && validationErrors[index].futureRateEndDate && (
                                                                                                <div className="invalid-feedback d-block">
                                                                                                    {validationErrors[index].futureRateEndDate}
                                                                                                </div>
                                                                                            )}
                                                                                        </div>
                                                                                    ) : (''))}

                                                                                </div>



                                                                                <DirectBillPlanCoverageComponent
                                                                                    key={plan.planId}
                                                                                    ref={(el) => (coverageRatesRefs.current[index] = el)}
                                                                                    planId={plan.planId}
                                                                                    planName={planName}
                                                                                    planRateType={plan.planRateType}
                                                                                    renewalCase={renewalCase}
                                                                                    isRatesChanging={plan.isRatesChanging}
                                                                                    isRenewal={plan.isRenewal === "true" || plan.isRenewal === "Yes"}
                                                                                    selectOptions={localSelectOptions}
                                                                                    isDisableForUsers={isDisableForUsers}
                                                                                    initialFormValues={{}}
                                                                                />
                                                                            </div>


                                                                        </div>
                                                                    )}




                                                                    <div className="col-lg-12">

                                                                        {(plan.planRateType === "Unit + Age/Gender" || plan.planRateType === "Age/Banded") && (
                                                                            <>
                                                                                <h5 className="card-title">Rate Information</h5>
                                                                                {plan.planRateType === "Unit + Age/Gender" && (
                                                                                    <div className="d-flex mb-2">
                                                                                    Dollar per Unit - 1000
                                                                                </div>
                                                                                )}
                                                                                
                                                                                {(plan.planRateType === "Age/Banded" || plan.planRateType === "Unit + Age/Gender") && (
                                                                                    <>
                                                                                        <Row className='mb-3'>


                                                                                            <Col lg={12} className='d-flex flex-column'>

                                                                                                <fieldset>
                                                                                                    <Form.Label className="mb-0">
                                                                                                        When should the premium update?
                                                                                                    </Form.Label>
                                                                                                    <div className="form-check-inline mb-2 ms-4">
                                                                                                        <input
                                                                                                            type="radio"
                                                                                                            className="emp-form-check-input"
                                                                                                            value="dob"
                                                                                                            name={`premiumUpdate_${index}`}
                                                                                                            id={`premiumUpdate_dob_${index}`}
                                                                                                            checked={plan?.premiumUpdate === "dob"}
                                                                                                            onChange={(e) => handleRadioChange(index, 'premiumUpdate', e)}
                                                                                                            disabled={isDisabled}
                                                                                                        />
                                                                                                        <label htmlFor={`premiumUpdate_${index}`} className='ms-2'>Date of Birth</label>
                                                                                                    </div>
                                                                                                    <div className="form-check-inline">
                                                                                                        <input
                                                                                                            type="radio"
                                                                                                            className="emp-form-check-input"
                                                                                                            value="PlanAnniversary"
                                                                                                            name={`premiumUpdate_${index}`}
                                                                                                            id={`premiumUpdate_PlanAnniversary_${index}`}
                                                                                                            checked={plan?.premiumUpdate === "PlanAnniversary"}
                                                                                                            onChange={(e) => handleRadioChange(index, 'premiumUpdate', e)}
                                                                                                            disabled={isDisabled}
                                                                                                        />
                                                                                                        <label htmlFor={`premiumUpdate_PlanAnniversary_${index}`} className='ms-2'>Plan Anniversary</label>
                                                                                                    </div>
                                                                                                    <div className="form-check-inline">
                                                                                                        <input
                                                                                                            type="radio"
                                                                                                            className="emp-form-check-input"
                                                                                                            value="dobOfDirectBillEnrollment"
                                                                                                            name={`premiumUpdate_${index}`}
                                                                                                            id={`premiumUpdate_dobOfDirectBillEnrollment_${index}`}
                                                                                                            checked={plan?.premiumUpdate === "dobOfDirectBillEnrollment"}
                                                                                                            onChange={(e) => handleRadioChange(index, 'premiumUpdate', e)}
                                                                                                            disabled={isDisabled}
                                                                                                        />
                                                                                                        <label htmlFor={`premiumUpdate_dobOfDirectBillEnrollment_${index}`} className='ms-2'>Date of Birth as of COBRA Enrollment Date</label>
                                                                                                    </div>
                                                                                                </fieldset>
                                                                                            </Col>

                                                                                        </Row>
                                                                                        <Row className='mb-3'>

                                                                                            <Col lg={12} className="d-flex align-items-start">
                                                                                                <Form.Label>
                                                                                                    Is there a cap for the number of dependents under the age of 20 for which the carrier bills?
                                                                                                </Form.Label>
                                                                                                <div className="form-check form-switch form-toggle">
                                                                                                    <input
                                                                                                        type="checkbox"
                                                                                                        className="form-check-input form-check-input-toggel toggle-input-switch"
                                                                                                        role="switch"
                                                                                                        checked={plan?.isDEPCap}
                                                                                                        onChange={(e) => handleBoolToggleChange(index, e, 'isDEPCap')}
                                                                                                        disabled={isDisabled}
                                                                                                    />
                                                                                                </div>
                                                                                            </Col>
                                                                                        </Row>

                                                                                        {plan?.isDEPCap && (
                                                                                            <Row className='mb-3'>
                                                                                            <Col lg={2}>
                                                                                                <Form.Label>
                                                                                                    If so, what is the cap?
                                                                                                </Form.Label>
                                                                                            </Col>
                                                                                            <Col lg={2} className="d-flex align-items-start">
                                                                                                <InputGroup>
                                                                                                    <Form.Control
                                                                                                        className={`form-control ${validationErrors[index] && validationErrors[index].cap ? 'is-invalid' : ''}`}
                                                                                                        title="depCap"
                                                                                                        type="text"
                                                                                                        name="depCap"
                                                                                                        placeholder=""
                                                                                                        value={plan?.depCap || ''}
                                                                                                        onChange={(e) => handleInputChange(index, e)}
                                                                                                        disabled={isDisabled}
                                                                                                    />
                                                                                                    {validationErrors[index] && validationErrors[index].capAmount && (
                                                                                                        <div className="invalid-feedback d-block">
                                                                                                            {validationErrors[index].capAmount}
                                                                                                        </div>
                                                                                                    )}
                                                                                                </InputGroup>
                                                                                            </Col>
                                                                                        </Row>
                                                                                        )}
                                                                                        
                                                                                    </>

                                                                                )}
                                                                            </>

                                                                        )}
                                                                        <h5 className="card-title">Required Documents</h5>

                                                                        <div className="d-flex">
                                                                            <em>{(plan.planRateType === "Age/Banded" || plan.planRateType === "Unit + Age/Gender") ? 'Please upload an Excel file with your age/gender banded medical rates in File Uploads section.' : 'Please upload required documents here.'}</em>
                                                                        </div>



                                                                        <div className="table-responsive">
                                                                            <table className="styled-table" cellSpacing="0" width="100%">
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th className="fileUploads-table-row">File Category</th>
                                                                                        <th colSpan="2" className="fileUploads-table-row">File Uploads</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {(plan.planRateType === "Age/Banded" || plan.planRateType === "Unit + Age/Gender") && (
                                                                                        <tr>
                                                                                            <th className="vertical-th fileUploadsDirectBillbenefits" scope="row">
                                                                                                <span className="browse-text pt-1">Age/Gender Banded Rates</span>
                                                                                            </th>
                                                                                            <td className="fileuploads-table-row">
                                                                                                <div className="upload-section-funding">
                                                                                                    <div className="d-flex justify-content-around mb-1">
                                                                                                        <input
                                                                                                            type="file"
                                                                                                            accept=".pdf, .xlsx, .xls, .csv"
                                                                                                            onChange={(e) => {
                                                                                                                handleFileChange(index, plan.planId, 'Age/Gender Banded Rates', e);
                                                                                                                
                                                                                                                e.target.value = null;
                                                                                                            }}
                                                                                                            disabled={isDisabled}
                                                                                                        />
                                                                                                        <label className="file-input-label pt-2">
                                                                                                            {selectedFileName[`${plan.planId}-${index}-Age/Gender Banded Rates`] ? (
                                                                                                                selectedFileName[`${plan.planId}-${index}-Age/Gender Banded Rates`]
                                                                                                            ) : (
                                                                                                                <>
                                                                                                                    Browse files here.<br />
                                                                                                                    Acceptable file formats include .pdf, .xlsx, .xls, and .csv
                                                                                                                </>
                                                                                                            )}
                                                                                                        </label>
                                                                                                        {selectedFile[`${plan.planId}-${index}-Age/Gender Banded Rates`] && (
                                                                                                            <button
                                                                                                                className="btn btn-success emp-upload-button btn-sm mt-2"
                                                                                                                onClick={() => uploadDirectBillBenefitsFile(index, plan.planId, "Age/Gender Banded Rates", plan.carrierName, plan.planName)}
                                                                                                                disabled={isDisabled}
                                                                                                            >
                                                                                                                Click to Upload
                                                                                                            </button>
                                                                                                        )}

                                                                                                    </div>
                                                                                                </div>
                                                                                            </td>
                                                                                        </tr>
                                                                                    )}
                                                                                    <tr>
                                                                                        <th className="vertical-th fileUploadsDirectBillbenefits" scope="row">
                                                                                            <span className="browse-text pt-1">Summary of Benefits and Coverage (SBC) Documents</span>
                                                                                        </th>
                                                                                        <td className="fileuploads-table-row">
                                                                                            <div className="upload-section-funding">
                                                                                                <div className="d-flex justify-content-around mb-1">
                                                                                                    <input
                                                                                                        type="file"
                                                                                                        accept=".pdf, .xlsx, .xls, .csv"
                                                                                                        onChange={(e) => {handleFileChange(index, plan.planId, 'Summary of Benefits and Coverage (SBC) Documents', e);
                                                                                                            e.target.value = null;
                                                                                                        }}
                                                                                                        disabled={isDisabled}
                                                                                                    />
                                                                                                    <label className="file-input-label pt-2">
                                                                                                        {selectedFileName[`${plan.planId}-${index}-Summary of Benefits and Coverage (SBC) Documents`] ? (
                                                                                                            selectedFileName[`${plan.planId}-${index}-Summary of Benefits and Coverage (SBC) Documents`]
                                                                                                        ) : (
                                                                                                            <>
                                                                                                                Browse files here.<br />
                                                                                                                Acceptable file formats include .pdf, .xlsx, .xls, and .csv
                                                                                                            </>
                                                                                                        )}
                                                                                                    </label>
                                                                                                    {selectedFile[`${plan.planId}-${index}-Summary of Benefits and Coverage (SBC) Documents`] && (
                                                                                                        <button
                                                                                                            className="btn btn-success emp-upload-button btn-sm mt-2"
                                                                                                            onClick={() => uploadDirectBillBenefitsFile(index, plan.planId, "Summary of Benefits and Coverage (SBC) Documents", plan.carrierName, plan.planName)}
                                                                                                            disabled={isDisabled}
                                                                                                        >
                                                                                                            Click to Upload
                                                                                                        </button>

                                                                                                    )}

                                                                                                </div>
                                                                                            </div>
                                                                                        </td>
                                                                                    </tr>
                                                                                </tbody>
                                                                            </table>


                                                                            {/* Error handling and validation */}
                                                                            {(plan.planRateType === "Age/Banded" || plan.planRateType === "Unit + Age/Gender") && (
                                                                                <>
                                                                                    {validationErrors[index] && validationErrors[index].fileUpload && (
                                                                                        <div className="invalid-feedback d-block">
                                                                                            {validationErrors[index].fileUpload}
                                                                                        </div>
                                                                                    )}
                                                                                </>
                                                                            )}
                                                                        </div>







                                                                        <div className='col-lg-10 '>
                                                                            <div className="table-responsive">

                                                                                <table className="table" cellSpacing="0" width="100%">
                                                                                    <thead>
                                                                                        <tr>
                                                                                            <th className="fileUploads-table-row">File Name</th>
                                                                                            <th className="fileUploads-table-row">File Category</th>
                                                                                            <th className="fileUploads-table-row">
                                        Uploaded Date
                                      </th>
                                                                                            <th className="fileUploads-table-row d-flex justify-content-center">Action</th>
                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody>
                                                                                        {files.filter(file => file.plan === planName && file.meta === plan.planId && file.status != "Deleted").map((file, idx) => (
                                                                                            <tr key={idx}>
                                                                                                <th className="vertical-th fileUploadsDirectBillbenefits" scope="row">
                                                                                                    <span className="FileURLElements browse-text">{getFileNameFromURL(file.fileURL)}</span>
                                                                                                </th>
                                                                                                <td>{file.fileCategory}</td>
                                                                                                <td>{ file.uploadedDate ? new Date(file.uploadedDate).toISOString().split('T')[0] : ''}</td>
                                                                                                <td className="d-flex justify-content-between">
                                                                                                    <a href={file.fileURL} className="" download="" style={{ textDecoration: 'none' }}>
                                                                                                        <FaDownload style={{ fontSize: '20px' }} />
                                                                                                    </a>
                                                                                                    <button type="button" className="deleteFile" disabled={isDisabled} onClick={() => handleDeleteFile(plan.planId, file.fileURL, file.id, file.fileCategory)}>
                                                                                                        <span className="fa fa-trash-alt me-1"></span>
                                                                                                    </button>
                                                                                                </td>

                                                                                            </tr>
                                                                                        ))}
                                                                                    </tbody>
                                                                                </table>

                                                                            </div>
                                                                        </div>





                                                                    </div>

                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="card-footer" id="footer">
                                                        <div className="col-lg-12">
                                                            {plan.isRenewal !== "Yes" && (
                                                                <button
                                                                    className="delete-plan-info"
                                                                    onClick={() => handleDeletePlan(index)} disabled={isDisabled}
                                                                >
                                                                    <span className="fa fa-trash-alt me-1" id="delete"></span>
                                                                </button>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}

                                    {planName === "FSA" && (
                                        <div className="d-flex  mb-2">
                                            <em>If you are changing vendors, please inactivate the existing carrier contact, and add new carrier contact in the “Enrollment and Eligibility” section below, if applicable.</em>
                                        </div>
                                    )}
                                    {plans.length > 0 && (
                                        <div className="row">
                                            <div className="col-lg-12 add-directBill-plans add-directBill-medical-plans" id="add-medical-button">
                                                <button
                                                    type="button"
                                                    className="btn btn-success btn-sm sm-btns my-1 float-end" disabled={isDisabled}
                                                    onClick={handleAddPlan}
                                                >
                                                    Add {planName} Plan
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
});

export default PlansComponent;
